/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Footer_RegistrationInputs */

const en_landing_footer_registration = /** @type {(inputs: Landing_Footer_RegistrationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inginuiti Limited is registered in England and Wales (No. 16924444). Registered office: 128 City Road, London, EC1V 2NX.`)
};

/**
* | output |
* | --- |
* | "Inginuiti Limited is registered in England and Wales (No. 16924444). Registered office: 128 City Road, London, EC1V 2NX." |
*
* @param {Landing_Footer_RegistrationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_footer_registration = /** @type {((inputs?: Landing_Footer_RegistrationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Footer_RegistrationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_footer_registration(inputs)
});